<!-- START: Financials Component -->
<section class="card mt-4 financeResult">
    <button aria-label="Close" class="close" type="button" data-dismiss="modal" (click)="closeModal()">
        <span aria-hidden="true">×</span>
    </button>
    
    <!-- Main Navigation: Profit & Loss | Balance Sheet -->
    <div class="financial-nav-buttons">
        <button 
            type="button" 
            class="btn-financial-nav"
            [class.active]="activeMainTab === 'profitAndLoss'"
            (click)="onMainTabChange('profitAndLoss')">
            Profit & Loss
        </button>
        <button 
            type="button" 
            class="btn-financial-nav"
            [class.active]="activeMainTab === 'balanceSheet'"
            (click)="onMainTabChange('balanceSheet')">
            Balance Sheet
        </button>
    </div>
    
    <div class="financial-content-wrapper">
        <!-- Profit & Loss Content -->
        <div class="financial-section" *ngIf="activeMainTab === 'profitAndLoss'">
            <div class="financial-sub-nav-buttons">
                <button 
                    type="button" 
                    class="btn-financial-sub-nav"
                    [class.active]="activePLTab === 'quarterly'"
                    (click)="onPLTabChange('quarterly')">
                    Quarterly Trend
                </button>
                <button 
                    type="button" 
                    class="btn-financial-sub-nav"
                    [class.active]="activePLTab === 'annual'"
                    (click)="onPLTabChange('annual')">
                    Annual Trend
                </button>
            </div>
            
            <div class="financial-type-nav-buttons">
                <button 
                    type="button" 
                    class="btn-financial-type-nav"
                    [class.active]="activeTypeTab === 'standalone'"
                    (click)="onTypeTabChange('standalone')">
                    Standalone
                </button>
                <button 
                    type="button" 
                    class="btn-financial-type-nav"
                    [class.active]="activeTypeTab === 'consolidated'"
                    (click)="onTypeTabChange('consolidated')">
                    Consolidated
                </button>
            </div>
            
            <div class="title-2">
                PROFIT & LOSS ({{ activePLTab === 'quarterly' ? 'QUARTERLY' : 'ANNUAL' }})
            </div>
            <!-- <div class="title-sub">
                Toggle view and type to explore Profit & Loss quickly.
            </div> -->
            
            <div class="content-area">
                <div *ngIf="activePLTab === 'quarterly'">
                    <!-- Standalone Quarterly P&L -->
                    <div *ngIf="activeTypeTab === 'standalone'">
                        <div *ngIf="isLoadingPLQuarterly" class="text-center my-3" style="padding: 40px;">
                            <i class="fa fa-spinner fa-spin fa-2x"></i>
                            <div style="margin-top: 10px;">Loading quarterly profit & loss data...</div>
                        </div>
                        <div *ngIf="!isLoadingPLQuarterly && (!arrangedDataStandalone || arrangedDataStandalone.length === 0)" class="text-center my-3" style="padding: 40px;">
                            <p>No quarterly profit & loss data available.</p>
                        </div>
                        
                        <!-- Charts Section - Show First -->
                        <div *ngIf="!isLoadingPLQuarterly && arrangedDataStandalone && arrangedDataStandalone.length > 0 && headerDatesStandalone && headerDatesStandalone.length > 0" class="mt-3 mb-4">
                            <h5 class="mb-3">Graphical Comparison</h5>
                            <div class="row">
                                <div class="col-md-12 mb-4">
                                    <div class="card">
                                        <div class="card-body">
                                            <h6 class="card-title text-center">Quarterly Profit & Loss - All Metrics</h6>
                                            <div style="position: relative; height: 500px;">
                                                <canvas id="quarterlyPLAllFieldsChartStandalone"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="card-block watermark" *ngIf="!isLoadingPLQuarterly && arrangedDataStandalone && arrangedDataStandalone.length > 0">
                            <div class="container" style="padding:0 20px 50px;">
                                <div class="table-responsive">
                                    <table class="table table-hover table-bordered table-striped dataTable" width="100%">
                                        <thead>
                                            <tr>
                                                <th>For The Period Ended</th>
                                                <th *ngFor="let h of headerDatesStandalone">{{ h }}</th>
                                              </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let row of arrangedDataStandalone">
                                                <td>{{ row.label }}</td>
                                                <td *ngFor="let h of headerDatesStandalone" class="text-end">
                                                  {{ displayValue(row[h], row.label || '') }}
                                                </td>
                                              </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Consolidated Quarterly P&L -->
                    <div *ngIf="activeTypeTab === 'consolidated'">
                        <div *ngIf="isLoadingPLQuarterly" class="text-center my-3" style="padding: 40px;">
                            <i class="fa fa-spinner fa-spin fa-2x"></i>
                            <div style="margin-top: 10px;">Loading quarterly profit & loss data...</div>
                        </div>
                        <div *ngIf="!isLoadingPLQuarterly && (!plQuarterlyDataConsolidated || plQuarterlyDataConsolidated.length === 0)" class="text-center my-3" style="padding: 40px;">
                            <p>No quarterly profit & loss data available.</p>
                        </div>
                        
                        <!-- Charts Section - Show First -->
                        <div *ngIf="!isLoadingPLQuarterly && arrangedDataConsolidated && arrangedDataConsolidated.length > 0 && dateHeadersConsolidated && dateHeadersConsolidated.length > 0" class="mt-3 mb-4">
                            <h5 class="mb-3">Graphical Comparison</h5>
                            <div class="row">
                                <div class="col-md-12 mb-4">
                                    <div class="card">
                                        <div class="card-body">
                                            <h6 class="card-title text-center">Quarterly Profit & Loss - All Metrics</h6>
                                            <div style="position: relative; height: 500px;">
                                                <canvas id="quarterlyPLAllFieldsChartConsolidated"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="card-block watermark" *ngIf="!isLoadingPLQuarterly && plQuarterlyDataConsolidated && plQuarterlyDataConsolidated.length > 0">
                            <div class="container" style="padding:0 20px 50px;">
                                <div class="table-responsive">
                                    <table class="table table-hover table-bordered table-striped dataTable" width="100%">
                                        <thead>
                                            <tr>
                                                <th>For The Period Ended</th>
                                                <th *ngFor="let h of dateHeadersConsolidated">{{ h }}</th>
                                              </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let row of arrangedDataConsolidated">
                                                <td>{{ row.label }}</td>
                                                <td *ngFor="let h of dateHeadersConsolidated" class="text-end">
                                                  {{ displayValue(row[h], row.label || '') }}
                                                </td>
                                              </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div *ngIf="activePLTab === 'annual'">
                    <!-- Standalone Annual P&L -->
                    <div *ngIf="activeTypeTab === 'standalone'">
                        <div *ngIf="isLoadingPLAnnual" class="text-center my-3" style="padding: 40px;">
                            <i class="fa fa-spinner fa-spin fa-2x"></i>
                            <div style="margin-top: 10px;">Loading annual profit & loss data...</div>
                        </div>
                        <div *ngIf="!isLoadingPLAnnual && (!plAnnualDataStandalone || plAnnualDataStandalone.length === 0)" class="text-center my-3" style="padding: 40px;">
                            <p>No annual profit & loss data available.</p>
                        </div>
                        
                        <!-- Charts Section - Show First -->
                        <div *ngIf="!isLoadingPLAnnual && plAnnualDataStandalone && plAnnualDataStandalone.length > 0 && plAnnualStandaloneHeaders && plAnnualStandaloneHeaders.length > 0" class="mt-3 mb-4">
                            <h5 class="mb-3">Graphical Comparison</h5>
                            <div class="row">
                                <div class="col-md-12 mb-4">
                                    <div class="card">
                                        <div class="card-body">
                                            <h6 class="card-title text-center">Annual Profit & Loss - All Metrics</h6>
                                            <div style="position: relative; height: 500px;">
                                                <canvas id="annualPLAllFieldsChartStandalone"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="card-block watermark" *ngIf="!isLoadingPLAnnual && plAnnualDataStandalone && plAnnualDataStandalone.length > 0">
                            <div class="container" style="padding:0 20px 50px;">
                                <div class="table-responsive">
                                    <table class="table table-hover table-bordered table-striped dataTable" width="100%">
                                        <thead>
                                            <tr>
                                                <th style="text-align: left;">For The Year Ended</th>
                                                <th *ngFor="let header of plAnnualStandaloneHeaders" style="text-align: right;">
                                                    {{ formatYearHeader(header) || '-' }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngFor="let row of plAnnualDataStandalone; let i = index">
                                                <!-- Insert section heading if needed -->
                                                <tr *ngIf="shouldInsertSectionHeading(row.label || row[0] || '', plAnnualDataStandalone[i-1]?.label || plAnnualDataStandalone[i-1]?.[0] || '', i)">
                                                    <td class="bs-main-heading" style="text-align: left; padding-left: 10px;">
                                                        {{ getSectionHeading(row.label || row[0] || '', i) }}
                                                    </td>
                                                    <td *ngFor="let header of plAnnualStandaloneHeaders" style="text-align: right;"></td>
                                                </tr>
                                                <!-- Data row -->
                                                <tr>
                                                    <td [ngClass]="getRowClass(row.label || row[0] || '')" [style.text-align]="'left'" [style.padding-left]="getRowPadding(row.label || row[0] || '')">
                                                        {{ row.label || row[0] || '-' }}
                                                    </td>
                                                    <td *ngFor="let header of plAnnualStandaloneHeaders" style="text-align: right;">
                                                        {{ displayValue(row[header], row.label || row[0] || '') }}
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Consolidated Annual P&L -->
                    <div *ngIf="activeTypeTab === 'consolidated'">
                        <div *ngIf="isLoadingPLAnnual" class="text-center my-3" style="padding: 40px;">
                            <i class="fa fa-spinner fa-spin fa-2x"></i>
                            <div style="margin-top: 10px;">Loading annual profit & loss data...</div>
                        </div>
                        <div *ngIf="!isLoadingPLAnnual && (!plAnnualDataConsolidated || plAnnualDataConsolidated.length === 0)" class="text-center my-3" style="padding: 40px;">
                            <p>No annual profit & loss data available.</p>
                        </div>
                        
                        <!-- Charts Section - Show First -->
                        <div *ngIf="!isLoadingPLAnnual && plAnnualDataConsolidated && plAnnualDataConsolidated.length > 0 && plAnnualConsolidatedHeaders && plAnnualConsolidatedHeaders.length > 0" class="mt-3 mb-4">
                            <h5 class="mb-3">Graphical Comparison</h5>
                            <div class="row">
                                <div class="col-md-12 mb-4">
                                    <div class="card">
                                        <div class="card-body">
                                            <h6 class="card-title text-center">Annual Profit & Loss - All Metrics</h6>
                                            <div style="position: relative; height: 500px;">
                                                <canvas id="annualPLAllFieldsChartConsolidated"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="card-block watermark" *ngIf="!isLoadingPLAnnual && plAnnualDataConsolidated && plAnnualDataConsolidated.length > 0">
                            <div class="container" style="padding:0 20px 50px;">
                                <div class="table-responsive">
                                    <table class="table table-hover table-bordered table-striped dataTable" width="100%">
                                        <thead>
                                            <tr>
                                                <th style="text-align: left;">For The Year Ended</th>
                                                <th *ngFor="let header of plAnnualConsolidatedHeaders" style="text-align: right;">
                                                    {{ formatYearHeader(header) || '-' }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngFor="let row of plAnnualDataConsolidated; let i = index">
                                                <!-- Insert section heading if needed -->
                                                <tr *ngIf="shouldInsertSectionHeading(row.label || row[0] || '', plAnnualDataConsolidated[i-1]?.label || plAnnualDataConsolidated[i-1]?.[0] || '', i)">
                                                    <td class="bs-main-heading" style="text-align: left; padding-left: 10px;">
                                                        {{ getSectionHeading(row.label || row[0] || '', i) }}
                                                    </td>
                                                    <td *ngFor="let header of plAnnualConsolidatedHeaders" style="text-align: right;"></td>
                                                </tr>
                                                <!-- Data row -->
                                                <tr>
                                                    <td [ngClass]="getRowClass(row.label || row[0] || '')" [style.text-align]="'left'" [style.padding-left]="getRowPadding(row.label || row[0] || '')">
                                                        {{ row.label || row[0] || '-' }}
                                                    </td>
                                                    <td *ngFor="let header of plAnnualConsolidatedHeaders" style="text-align: right;">
                                                        {{ displayValue(row[header], row.label || row[0] || '') }}
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Balance Sheet Content -->
        <div class="financial-section" *ngIf="activeMainTab === 'balanceSheet'">
            <div class="financial-type-nav-buttons">
                <button 
                    type="button" 
                    class="btn-financial-type-nav"
                    [class.active]="activeTypeTab === 'standalone'"
                    (click)="onTypeTabChange('standalone')">
                    Standalone
                </button>
                <button 
                    type="button" 
                    class="btn-financial-type-nav"
                    [class.active]="activeTypeTab === 'consolidated'"
                    (click)="onTypeTabChange('consolidated')">
                    Consolidated
                </button>
            </div>
            
            <div class="title-2">
                BALANCE SHEET ({{ activeTypeTab === 'standalone' ? 'STANDALONE' : 'CONSOLIDATED' }})
            </div>
            <!-- <div class="title-sub">
                Switch type to review the corresponding Balance Sheet.
            </div> -->
            
            <div class="content-area">
                <!-- Standalone Balance Sheet -->
                <div *ngIf="activeTypeTab === 'standalone'">
                    <div *ngIf="isLoadingBSStandalone" class="text-center my-3" style="padding: 40px;">
                        <i class="fa fa-spinner fa-spin fa-2x"></i>
                        <div style="margin-top: 10px;">Loading standalone balance sheet data...</div>
                    </div>
                    <div *ngIf="!isLoadingBSStandalone && (!balanceSheetStandaloneData || balanceSheetStandaloneData.length === 0)" class="text-center my-3" style="padding: 40px;">
                        <p>No standalone balance sheet data available.</p>
                        <p style="font-size: 12px; color: #666;">Data length: {{ balanceSheetStandaloneData?.length || 0 }}</p>
                    </div>
                    
                    <!-- Charts Section - Show First -->
                    <div *ngIf="!isLoadingBSStandalone && balanceSheetStandaloneData && balanceSheetStandaloneData.length > 0 && balanceSheetStandaloneHeaders && balanceSheetStandaloneHeaders.length > 0" class="mt-3 mb-4">
                        <h5 class="mb-3">Graphical Comparison</h5>
                        <div class="row">
                            <div class="col-md-12 mb-4">
                                <div class="card">
                                    <div class="card-body">
                                        <h6 class="card-title text-center">Balance Sheet - All Metrics</h6>
                                        <div style="position: relative; height: 500px;">
                                            <canvas id="balanceSheetAllFieldsChartStandalone"></canvas>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="card-block watermark" *ngIf="!isLoadingBSStandalone && balanceSheetStandaloneData && balanceSheetStandaloneData.length > 0">
                        <div class="container" style="padding:0 20px 50px;">
                            <div class="table-responsive">
                                <table class="table table-hover table-bordered table-striped dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th style="text-align: left;">For The Year Ended</th>
                                            <th *ngFor="let header of balanceSheetStandaloneHeaders" style="text-align: right;">
                                                {{ formatYearHeader(header) || '-' }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let row of balanceSheetStandaloneData; let i = index">
                                            <!-- Insert section heading (ASSETS or EQUITIES AND LIABILITIES) before appropriate rows -->
                                            <tr *ngIf="shouldInsertSectionHeading(row.label || row[0] || '', balanceSheetStandaloneData[i-1]?.label || balanceSheetStandaloneData[i-1]?.[0] || '', i)">
                                                <td class="bs-main-heading" style="text-align: left; padding-left: 10px;">
                                                    {{ getSectionHeading(row.label || row[0] || '', i) }}
                                                </td>
                                                <td *ngFor="let header of balanceSheetStandaloneHeaders" style="text-align: right;"></td>
                                            </tr>
                                            <!-- Data row -->
                                            <tr>
                                                <td [ngClass]="getRowClass(row.label || row[0] || '')" [style.text-align]="'left'" [style.padding-left]="getRowPadding(row.label || row[0] || '')">
                                                    {{ row.label || row[0] || '-' }}
                                                </td>
                                                <td *ngFor="let header of balanceSheetStandaloneHeaders" style="text-align: right;">
                                                    {{ displayValue(row[header], row.label || row[0] || '') }}
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Consolidated Balance Sheet -->
                <div *ngIf="activeTypeTab === 'consolidated'">
                    <div *ngIf="isLoadingBSConsolidated" class="text-center my-3" style="padding: 40px;">
                        <i class="fa fa-spinner fa-spin fa-2x"></i>
                        <div style="margin-top: 10px;">Loading consolidated balance sheet data...</div>
                    </div>
                    <div *ngIf="!isLoadingBSConsolidated && (!balanceSheetConsolidatedData || balanceSheetConsolidatedData.length === 0)" class="text-center my-3" style="padding: 40px;">
                        <p>No consolidated balance sheet data available.</p>
                    </div>
                    
                    <!-- Charts Section - Show First -->
                    <div *ngIf="!isLoadingBSConsolidated && balanceSheetConsolidatedData && balanceSheetConsolidatedData.length > 0 && balanceSheetConsolidatedHeaders && balanceSheetConsolidatedHeaders.length > 0" class="mt-3 mb-4">
                        <h5 class="mb-3">Graphical Comparison</h5>
                        <div class="row">
                            <div class="col-md-12 mb-4">
                                <div class="card">
                                    <div class="card-body">
                                        <h6 class="card-title text-center">Balance Sheet - All Metrics</h6>
                                        <div style="position: relative; height: 500px;">
                                            <canvas id="balanceSheetAllFieldsChartConsolidated"></canvas>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="card-block watermark" *ngIf="!isLoadingBSConsolidated && balanceSheetConsolidatedData && balanceSheetConsolidatedData.length > 0">
                        <div class="container" style="padding:0 20px 50px;">
                            <div class="table-responsive">
                                <table class="table table-hover table-bordered table-striped dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th style="text-align: left;">For The Year Ended</th>
                                            <th *ngFor="let header of balanceSheetConsolidatedHeaders" style="text-align: right;">
                                                {{ formatYearHeader(header) || '-' }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let row of balanceSheetConsolidatedData; let i = index">
                                            <!-- Insert section heading (ASSETS or EQUITIES AND LIABILITIES) before appropriate rows -->
                                            <tr *ngIf="shouldInsertSectionHeading(row.label || row[0] || '', balanceSheetConsolidatedData[i-1]?.label || balanceSheetConsolidatedData[i-1]?.[0] || '', i)">
                                                <td class="bs-main-heading" style="text-align: left; padding-left: 10px;">
                                                    {{ getSectionHeading(row.label || row[0] || '', i) }}
                                                </td>
                                                <td *ngFor="let header of balanceSheetConsolidatedHeaders" style="text-align: right;"></td>
                                            </tr>
                                            <!-- Data row -->
                                            <tr>
                                                <td [ngClass]="getRowClass(row.label || row[0] || '')" [style.text-align]="'left'" [style.padding-left]="getRowPadding(row.label || row[0] || '')">
                                                    {{ row.label || row[0] || '-' }}
                                                </td>
                                                <td *ngFor="let header of balanceSheetConsolidatedHeaders" style="text-align: right;">
                                                    {{ displayValue(row[header], row.label || row[0] || '') }}
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


